export default "__VITE_ASSET__B3vRZ0Me__"